<template>
    <div class="row"><h3></h3></div>
  </template>
  
  
  <script>
  import router from "@/router"
      export default {
          mounted() {
              router.push("/dashboard");
          }
      }
  </script>
  ~             